import { styled } from '@mui/material';

export const sxStyles = {
  labelContainer: {
    '& > p:first-of-type': {
      fontWeight: 700,
      marginRight: '0.25rem',
    },
  },
  accountConnectionContent: {
    display: 'flex',
    gap: '24px',
  },
  accountConnectionContentItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
};

export const StyledHeader = styled('div')(({ theme }) => ({
  marginBottom: '24px',
}));

export const StyledAccountConnectionContent = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'column',
  gap: '1rem',
}));
